import { JobDetails, JobFailure } from '../../../../interfaces/job';
import { JOB_STATS_BOX_DATA_IDS } from '../../data-ids';
import { IconButton } from '../../../../../button/IconButton/IconButton';
import { Icon } from '../../../../../icon/Icon';
import { JobModeIdBadge } from '../../../JobModeIdBadge/JobModeIdBadge';
import { JobStatsTable } from '../JobStatsTable/JobStatsTable';
import { GenericStatusLabel } from '../../../../../shared/components/GenericStatusLabel/GenericStatusLabel';
import { useMemoizedDataIds } from '../../../../../shared/utils/dataId';
import { JobFailureBanner } from '../JobFailureBanner';
import { EntityActions } from '../../../../../entity-actions/EntityActions';
import { JOB_ACTIONS_CONFIRMATION_DIALOG_PROPS } from '../../../../constants/job-actions-confirm-dialog-props';
import { useJobActions } from './hooks/useJobActions';
import { JobDetailsFactory } from '../../../../factory';
import { JobDetailsRawData } from '../../../../interfaces/raw-data';

export interface JobStatsBoxProps {
  pipelineId: number;
  jobDetails: JobDetails;
  jobFailures: JobFailure[];
  latencyNotApplicable: boolean;
  dataId?: string;
  onRefreshClick: VoidFunction;
}

export function JobStatsBox({
  pipelineId,
  jobDetails,
  jobFailures,
  dataId,
  latencyNotApplicable,
  onRefreshClick
}: JobStatsBoxProps) {
  const { jobId, status, mode, stats, isLoadOnly } = jobDetails;

  const jobStatsBoxDataIds = useMemoizedDataIds(JOB_STATS_BOX_DATA_IDS, dataId);

  const { jobActions, navigateToJobsList } = useJobActions({
    onRefreshClick,
    jobDetails,
    pipelineId
  });

  return (
    <div data-id={jobStatsBoxDataIds.jobStats} className='box'>
      <div className='box__header'>
        <div className='center-flex-row'>
          <IconButton
            onClick={navigateToJobsList}
            dataId={jobStatsBoxDataIds.backBtn}
            label='Go Back'
          >
            <Icon name='add-arrow-left' className='text-default' />
          </IconButton>

          <div className='ml-3'>
            <JobModeIdBadge mode={mode} jobId={jobId} />
          </div>

          <span className='ml-2 text-surface-border'>&bull;</span>

          <div className='ml-2' data-id={jobStatsBoxDataIds.status}>
            <GenericStatusLabel status={status} withIcon />
          </div>
        </div>

        <EntityActions
          actions={jobActions}
          entity={jobDetails}
          confirmationDialogProps={JOB_ACTIONS_CONFIRMATION_DIALOG_PROPS}
          getEntityFromActionResponse={res => JobDetailsFactory(res as JobDetailsRawData)}
        />
      </div>

      <div className='box__body'>
        {jobFailures.length ? <JobFailureBanner jobFailures={jobFailures} /> : null}

        <JobStatsTable
          stats={stats}
          isLoadOnly={isLoadOnly}
          latencyNotApplicable={latencyNotApplicable}
        />
      </div>
    </div>
  );
}
